/**
 * tdesign v0.44.2
 * (c) 2022 tdesign
 * @license MIT
 */

import useConfig from './useConfig.js';
import 'react';
import '../config-provider/ConfigContext.js';
import '../_chunks/dep-74ef9ead.js';
import '../_chunks/dep-5eadc4f3.js';
import '../_chunks/dep-7a9656a6.js';
import '../_chunks/dep-fd215ab0.js';
import '../_chunks/dep-8127363b.js';
import '../_chunks/dep-a0b71ae4.js';
import '../_chunks/dep-670cc86e.js';
import '../_chunks/dep-da112583.js';
import '../_chunks/dep-dfae10c3.js';
import '../_chunks/dep-f4495ac9.js';
import '../_chunks/dep-6c09308a.js';
import '../_chunks/dep-4ca52001.js';
import '../_chunks/dep-408df89a.js';
import '../_chunks/dep-e755a9cb.js';
import '../_chunks/dep-1e4c771d.js';
import '../_chunks/dep-15d0e734.js';
import '../_chunks/dep-b0c02324.js';
import '../_chunks/dep-a09b6dac.js';
import '../_chunks/dep-1792ab93.js';
import '../_chunks/dep-9c2f4c72.js';
import '../_chunks/dep-da7344ec.js';
import '../_chunks/dep-01fe0fd1.js';
import '../_chunks/dep-20a8e46d.js';
import '../_chunks/dep-9d067299.js';
import '../locale/zh_CN.js';
import '../_common/js/global-config/locale/zh_CN.js';
import '../_common/js/global-config/default-config.js';

function useGlobalIcon(tdIcon) {
  var _useConfig = useConfig(),
    globalIcon = _useConfig.icon;
  var resultIcon = {};
  Object.keys(tdIcon).forEach(function (key) {
    resultIcon[key] = (globalIcon === null || globalIcon === void 0 ? void 0 : globalIcon[key]) || tdIcon[key];
  });
  return resultIcon;
}

export { useGlobalIcon as default };
//# sourceMappingURL=useGlobalIcon.js.map
